<template lang="html">
  <div class="data-container">
    <div v-if="fetchData.length > 0">
      <component
        :is="viewName"
        :items="fetchData"
        :params="otherParams"
        v-scroll="next"
      ></component>
      <div v-show="fetching" class="data-action data-loading">
        <i class="iconfont icon-jiazai"></i>加载中
      </div>
      <div
        class="data-action data-more"
        @click="next"
        v-show="!fetching && isLoadAll && page !== 1"
      >
        {{ isLoadAll ? `已经到底啦` : `` }}
      </div>
    </div>
    <empty
      class="inside"
      :top="otherParams.top ? otherParams.top : '2.8rem'"
      v-else
      v-show="!firstFetch"
      :text="hasErr ? '出错了' : otherParams.errText"
      :image="hasErr ? null : otherParams.errImg"
      :errorClass="hasErr ? null : otherParams.errorClass"
    ></empty>
  </div>
</template>

<script>
import empty from '../common/empty'
import workerList from '../work/list'
import allWorkerList from '../work/listWithAllStatus'
import evaluateList from '../rear/evaluate'
import experienceList from '../rear/experience-list'
import servicesList from '../rear/services'
import servicesSkuList from '../product/list'
// import commentList from '../common/comment/list'
import orderList from '../order/orderList'
import storeAllWorkers from '../work/listWithStore'
// import commentMemberList from '../common/comment/memberList'
import groupList from '../groupBuy/groupList'
import sevOrderlist from '../serviceLog/orderList'
import sevLoglist from '../serviceLog/logList'
import shareListItem from '@/components/activity/shareListItem'
import commentPersonList from '@/components/newComment/commentPersonList'
import commentProductList from '@/components/newComment/commentProductList'
import consultantListWorkers from '@/components/consultantList/workers'

export default {
  props: {
    viewName: {
      type: String
    },
    fetchMethod: {
      type: Function,
      default: () => () => {}
    },
    fetchData: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      defaut: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    controlPage: {
      type: Function,
      default: () => () => {}
    },
    // 是否为第一次请求
    firstFetch: {
      type: Boolean,
      default: true
    },
    // 外部数据请求是否有异常
    hasErr: {
      type: Boolean,
      default: false
    },
    // 其他参数
    otherParams: {
      type: Object,
      default() {
        return {
          errText: '暂无内容'
        }
      }
    }
  },
  data() {
    return {
      fetching: false
    }
  },
  computed: {
    isLoadAll() {
      return this.fetchData.length < this.pageSize * this.page
    }
  },
  methods: {
    async fetch() {
      if (this.isLoadAll) return
      await this.fetchMethod()
    },
    async next() {
      if (this.isLoadAll || this.fetching) return
      this.controlPage(this.page + 1)
      this.fetching = true
      await this.fetch()
      this.fetching = false
    }
  },
  components: {
    workerList,
    empty,
    // commentList,
    allWorkerList,
    evaluateList,
    servicesList,
    orderList,
    servicesSkuList,
    experienceList,
    storeAllWorkers,
    // commentMemberList,
    groupList,
    sevOrderlist,
    sevLoglist,
    shareListItem,
    commentPersonList,
    commentProductList,
    consultantListWorkers
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.data-container {
  width: 100%;
  .data-action {
    height: rem(86px);
    line-height: rem(86px);
    text-align: center;
    color: #999;
    /*background-color:#f4f4f4;*/
  }
  .data-loading {
    font-size: rem(32px);
    .icon-jiazai {
      display: inline-block;
      margin-right: rem(10px);
      animation: rotating 2s linear infinite;
    }
  }
  .data-more {
    display: none;
  }
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
